import React, { useEffect, useRef, useState } from "react";
import { IoIosClose } from "react-icons/io";
import { useHistory, useLocation, useParams } from "react-router-dom";
import EuropeanInput from "../../utils/European-Format/EuropeanInput";
import PercentageFormatter from "../../utils/European-Format/PercentageFormatter";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import SendEmailROpopup from "../../components/Dailogs/SendEmailROpopup";
import Header from "../../layouts/Header";
import "../../assets/styles/local/AddPurchasingOrder.css";
import "../../assets/styles/local/AddRentOrder.css";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import ColorTag from "./ColorTag";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Package from "../../assets/icons/package.svg";
import circleCheck from "../../assets/icons/circle-check.svg";
import Calender from "../../assets/icons/CalendarGray.svg";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import {
  Addpurchasingorder,
  FetchProductBysupplierid,
  Fetchlastordercode,
  Fetchprojects,
  Fetchsuppliers,
  fetchTranslationData,
  setStatusToFalse,
  FetchProductWithoutSupplier,
  AddSupplierToProduct,
  SupplierBarCode,
  SupplierCodeExistOrNot,
  SendPurchasingOrderSupplier,
  FetchUnits,
  AddProductPart,
  PartDuplicate,
  ProductpartBarCode,
  UpdateDuplicatePoPartName,
  PO_Supplier_Props_API,
} from "../../redux/actions/action";
import {
  ADD_PURCHASING_ORDER,
  ADD_SUPPLIER_TO_PRODUCT,
} from "../../redux/constants/type";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "react-bootstrap";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import AppDatePicker from "../../components/Common/AppDatePicker";
import { Dropdown } from "antd";
import { CrossCircleIcon } from "../../assets/svgs/SvgsImg";
import PlusIcon from "../../assets/images/Plus.svg";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { SyncOutlined } from "@ant-design/icons";
import AddPurchaseOrderDocument from "./AddPurchaseOrderDocument";
import BarcodeGenerator from "./BarcodeGenerator";
import CurrencyInput from "react-currency-input";

const AddRentOrder = () => {
  const dispatch = useDispatch();

  const asc_current_webUrl = window.location.host;

  useEffect(() => {
    if (asc_current_webUrl === "essentials-uat.spire.solutions") {
      setToggleActive(false);
    }
  });

  const { jitOrder, productPartsupplierCode, productPartCode } = useParams();

  const history = useHistory();
  const location = useLocation();
  const locationState = location.state;
  const supplierFieldRef = useRef(null);
  const type_supplier_Drop_Ref = useRef(null);
  const type_project_Drop_Ref = useRef(null);
  const type_an_item_Drop_Ref = useRef(null);
  const dragWidthsRef = useRef({});

  const fetchPoOrderCode = useSelector((state) => state.user.fetchPoOrderCode);
  const fetchSuppliers = useSelector((state) => state.user.fetchSuppliers);
  const fetchProjects = useSelector((state) => state.user.fetchProjects);
  const fetchProductBySupplierId = useSelector(
    (state) => state.user.fetchProductBySupplierId,
  );
  const addPurchasingOrder = useSelector(
    (state) => state.user.addPurchasingOrder,
  );

  const purchaseOrder = useSelector((state) => state.user.JITPurchaseOrderList);

  const poSupplierNameIDRes = useSelector(
    (state) => state.user.poSupplierNameIDRes,
  );

  const fetchProductsWithoutSupplierRes = useSelector(
    (state) => state.user.fetchProductsWithoutSupplierRes,
  );

  const addSupplierToProductsRes = useSelector(
    (state) => state.user.addSupplierToProductsRes,
  );

  const supplierBarCodeRes = useSelector(
    (state) => state.user.supplierBarCodeRes,
  );
  // console.log("asc67",poSupplierNameIDRes)

  //////////////  VARIABLES START //////////////

  const [showLoader, setShowLoader] = useState(true);

  const [poOrderCode, setPoOrderCode] = useState("");
  const [apimessage, setApimessage] = useState("");
  const [toggleActive, setToggleActive] = useState(true);
  let [qty, setQty] = useState("1");
  let [weight, setWeight] = useState(null);
  let [discount, setDiscount] = useState("0");
  const [orderType, setOrderType] = useState("Rent");
  const [isClicked, setIsClicked] = useState(false);

  const [openUnitIndex, setOpenUnitIndex] = useState(null);
  const [unitData, setUnitData] = useState([]);

  const screenSize = useScreenSize();

  useEffect(() => {
    dispatch(FetchUnits()).then((res) => {
      if (res.status) {
        setUnitData(res.data);
      }
    });
  }, []);

  function convertToNumber(str) {
    if (typeof str === "number") return str;
    if (typeof str !== "string" || str.trim() === "") return NaN;
    const formattedStr = str
      .replace("€", "")
      .replace(/\s/g, "")
      .replace(/\./g, "")
      .replace(",", ".");

    const number = parseFloat(formattedStr);
    return isNaN(number) ? NaN : number;
  }

  // FETCH PO ORDER CODE START //

  useEffect(() => {
    dispatch(Fetchlastordercode());
  }, []);

  useEffect(() => {
    if (fetchPoOrderCode.status === true) {
      console.log("Data======>", fetchPoOrderCode.data);
      setPoOrderCode(fetchPoOrderCode.data);
    } else {
      setApimessage(fetchPoOrderCode?.message);
    }
  }, [fetchPoOrderCode]);

  // FETCH PO ORDER CODE END //

  //////////// ASC Fetch Suppliers Start //////////

  const [showDropPeople, setShowDropPeople] = useState(false);
  const [suppliersData, setSuppliersData] = useState([]);
  const [searchPeople, setSearchPeople] = useState(
    poSupplierNameIDRes?.poSupplierName,
  );
  const [suppliersEmail, setSuppliersEmail] = useState("");
  const [suppliersName, setSuppliersName] = useState("");
  const [suppliersId, setSuppliersId] = useState(
    poSupplierNameIDRes?.poSupplierID,
  );

  // useEffect(() => {
  //   if(true){
  //     setSearchPeople(poSupplierNameIDRes?.poSupplierName);
  //     setSuppliersId(poSupplierNameIDRes?.poSupplierID)
  //   }
  // }, [poSupplierNameIDRes]);

  useEffect(() => {
    dispatch(Fetchsuppliers());
  }, []);

  useEffect(() => {
    if (fetchSuppliers.status === true) {
      // setApimessage(fetchSuppliers?.message)
      setSuppliersData(fetchSuppliers.data);

      if (productPartsupplierCode && productPartCode) {
        setFilelist([]);
        const people = fetchSuppliers.data.filter(
          (o) => o.supplierid == productPartsupplierCode,
        );

        if (people.length > 0) {
          setSearchPeople(people[0].suppliername);
          setSuppliersId(people[0].supplierid);
          dispatch(FetchProductBysupplierid(people[0].supplierid, jitOrder));
        } else {
          dispatch(FetchProductBysupplierid(productPartsupplierCode, jitOrder));
        }
      }
    } else {
      setApimessage(fetchSuppliers?.message);
    }
  }, [fetchSuppliers]);

  ///////////// ASC Fetch Suppliers End ///////////

  ///////////// ASC Fetch Projects Start ///////////

  const [projectsData, setProjectsData] = useState([]);
  const [showProjectsPeople, setShowProjectsPeople] = useState(false);
  const [projectSearchPeople, setProjectSearchPeople] = useState("");
  const [projectId, setProjectId] = useState("");
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    dispatch(Fetchprojects());
  }, []);

  useEffect(() => {
    fetchScreenTranslations("Add Purchasing Order").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  console.log("FetchTranslationList Data ===========>", FetchTranslationList);

  useEffect(() => {
    if (fetchProjects.status === true) {
      // setApimessage(fetchProjects?.message)
      setProjectsData(fetchProjects.data);
    } else {
      setApimessage(fetchProjects?.message);
    }
  }, [fetchProjects]);

  ///////////// ASC Fetch Projects End ///////////

  ///////// ASC Fetch Product by Supplier id START /////

  const [fetchProductsData, setFetchProductsData] = useState([]);
  const [showProductsPeople, setShowProductsPeople] = useState(false);
  const [productsSearchPeople, setProductsSearchPeople] = useState("");
  const [productColor, setProductColor] = useState("");
  const [costprice, setCostprice] = useState("");
  const [instock, setInstock] = useState("");
  const [itemid, setItemid] = useState("");
  const [productpartname, setProductpartname] = useState("");
  const [productPartid, setProductPartid] = useState("");
  const [isAddNewParts, setIsAddNewParts] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isSupplierCodeExist, setIsSupplierCodeExist] = useState({
    status: false,
    suppCodeIndex: null,
  });
  const [productsWithoutSupplier, setProductsWithoutSupplier] = useState([]);

  const [filelist, setFilelist] = useState([]);

  useEffect(() => {
    dispatch(FetchProductWithoutSupplier());
  }, [isAddNewParts]);

  useEffect(() => {
    if (fetchProductsWithoutSupplierRes.status === true) {
      const list = fetchProductsWithoutSupplierRes.data.map((item) => ({
        ...item,
        costprice: convertToNumber(item?.supplier?.[0]?.costprice || 0),
      }));
      setProductsWithoutSupplier(list);
    }
  }, [fetchProductsWithoutSupplierRes]);

  useEffect(() => {
    if (addSupplierToProductsRes.status === true) {
      // setShowSendEmailPopup(true);

      dispatch({
        type: ADD_SUPPLIER_TO_PRODUCT,
        data: {},
      });
    }
  }, [addSupplierToProductsRes]);

  console.log("asc3 rent", location.state);

  useEffect(() => {
    const projectNAME = window.localStorage.getItem("projectname");
    const projectID = window.localStorage.getItem("projectid");
    if (projectNAME && projectID && location.state === "/updateProject") {
      setProjectId(projectID);
      setProjectSearchPeople(projectNAME);
    } else {
      setProjectId("");
      setProjectSearchPeople("");
    }

    if (location.state && location.state.fromQuotes) {
      if (location.state.projectId) {
        setProjectId(location.state.projectId);
      }

      if (location.state.projectname)
        setProjectSearchPeople(location.state.projectname);

      if (location.state.supplierid) {
        setSuppliersId(location.state.supplierid);
        dispatch(FetchProductBysupplierid(location.state.supplierid, jitOrder));
      }

      if (location.state.suppliername)
        setSearchPeople(location.state.suppliername);

      if (location.state.product) {
        let stockList = [];
        let productData = location.state.product;

        stockList.push({
          asc_productpartname: productData.productPartName,
          asc_productPartid: productData.productPartId,
          asc_productColor: productData.color,
          asc_costprice: productData.costPrice,
          qty: productData.quantity,
          // asc_instock: people.instock,
          asc_leadTime: productData.leadtime,
          asc_Unit: productData.unit,
          asc_itemid: productData.itemId,
          discount: 0,
          weight: null,
          Total: productData.costPrice * productData.quantity,
        });

        setFilelist(stockList);
      }
    }
  }, []);

  useEffect(() => {
    if (fetchProductBySupplierId.status === true) {
      // setApimessage(fetchProductBySupplierId?.message)
      const list = fetchProductBySupplierId.data.map((item) => ({
        ...item,
        costprice: convertToNumber(item.costprice),
      }));
      setFetchProductsData(list);
      setShowLoader(false);

      if (productPartsupplierCode && productPartCode) {
        let lowStockList = [];
        fetchProductBySupplierId.data.forEach((o) => {
          if (o.productPartid == productPartCode) {
            if (jitOrder) {
              let obj =
                purchaseOrder && purchaseOrder?.data
                  ? purchaseOrder?.data.find(
                      (p) => p.productId === o.productPartid,
                    )
                  : null;
              let quantity =
                obj && obj.orderProductQty ? obj.orderProductQty : 1;
              lowStockList.push({
                asc_productpartname: o.productpartname,
                asc_productPartid: o.productPartid,
                asc_productColor: o.color,
                asc_costprice: convertToNumber(o.costprice),
                qty: quantity,
                // asc_instock: people.instock,
                asc_leadTime: o.leadtime,
                asc_Unit: o.unit,
                asc_itemid: o.itemid,
                discount: 0,
                weight: null,
                Total: o.costprice * quantity,
              });
            } else if (
              o.lowStock &&
              o.stockToBuy > 0 &&
              o.productPartid == productPartCode
            ) {
              lowStockList.push({
                asc_productpartname: o.productpartname,
                asc_productPartid: o.productPartid,
                asc_productColor: o.color,
                asc_costprice: o.costprice,
                qty: o.stockToBuy,
                // asc_instock: people.instock,
                asc_leadTime: o.leadtime,
                asc_Unit: o.unit,
                asc_itemid: o.itemid,
                discount: 0,
                weight: null,
                Total: o.costprice * o.stockToBuy,
              });
            }
          }
        });
        setFilelist(lowStockList);
      }
    } else {
      setApimessage(fetchProductBySupplierId?.message);
      setFetchProductsData([]);
    }
  }, [fetchProductBySupplierId]);

  ////// ASC Fetch Product by Supplier id END ///////

  const [leadTimeChange, setLeadTimeChange] = useState({});
  const [priceChange, setPriceChange] = useState({});

  ///////////// ASC Addpurchasingorder API Start ///////////

  const array = [];
  for (let index = 0; index < filelist.length; index++) {
    array.push({
      productid: filelist[index].asc_productPartid,
      // orderproductqty: filelist[ index ].qty,
      orderproductqty: filelist[index].qty ? filelist[index].qty : qty,
      productDiscount: filelist[index].discount
        ? filelist[index].discount
        : discount,
      productWeight: filelist[index].weight ? filelist[index].weight : weight,
      leadtime: leadTimeChange[index] ? filelist[index].asc_leadTime : "",
      // unitprice: priceChange[index] ? filelist[index].asc_costprice : "",
      unitprice: priceChange[index]
        ? Number(filelist[index].asc_costprice).toFixed(2).replace(".", ",")
        : "",
      indexPosition: index + 1,
    });
  }

  const [orderCode, setOrderCode] = useState("");

  const HandleAddOrder = () => {
    setLoader(true);
    if (isClicked) return;

    setTypeField("");
    const totalexclusivebtw = filelist.reduce((a, b) => (a = a + b.Total), 0);
    const totalinclusivebtw =
      (+totalexclusivebtw * 21) / 100 + +totalexclusivebtw;

    const fromDate = rentPeriod?.fromDate || null; // Fallback to null if undefined
    const toDate = rentPeriod?.toDate || null; // Fallback to null if undefined

    setIsClicked(true);

    dispatch(
      Addpurchasingorder(
        productpartname,
        suppliersId,
        projectId ? projectId : null,
        array,
        // array.filter((item) =>
        //   filelist.find(
        //     (x) => x.asc_productPartid === item.productid && x.asc_SupplierId,
        //   ),
        // ),
        toggleActive,
        totalexclusivebtw,
        totalinclusivebtw.toString(),
        deliveryAddress,
        orderType,
        fromDate,
        toDate,
      ),
    );

    if (
      filelist?.some(
        (item) => item.asc_SupplierId !== suppliersId || item.isCopy,
      )
    ) {
      // dispatch(
      //   SupplierBarCode({
      //     itemids: filelist.map((item) => item.asc_itemid),
      //   }),
      // ).then((res) => {
      dispatch(
        AddSupplierToProduct({
          productpartsuppliers: filelist
            ?.filter(
              (item) => item.asc_SupplierId !== suppliersId || item.isCopy,
            ) // jinke suppid current suppliersId se match nhi hai
            ?.map((item) => {
              // const barcodeObj = res?.data?.find(
              //   (x) => x.itemid === item.asc_itemid,
              // );
              return {
                productPartid: item.asc_productPartid,
                supplierid: suppliersId,
                itemid: item.asc_itemid || "",
                // costprice: item.asc_costprice || "",
                costprice: Number(item.asc_costprice)
                  .toFixed(2)
                  .replace(".", ","),
                leadtime: item.asc_leadTime || "",
                // barCode: barcodeObj?.url || "",
              };
            }),
        }),
      );
      // }); .then ka block
    }
  };

  useEffect(() => {
    if (toggleActive && loader) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "We are sending email to suppliers. This may take some time. Please wait...",
        },
        false,
      );
    }
  }, [loader, toggleActive]);

  useEffect(() => {
    if (addPurchasingOrder.status === true) {
      const createdOrderId = addPurchasingOrder?.data?.orderid;
      const createdOrderCode = addPurchasingOrder?.data?.ordercode || "";

      setOrderCode(createdOrderCode);

      if (toggleActive && createdOrderId) {
        dispatch({
          type: "START_RENT_ORDER_EMAIL_JOB",
          data: {
            requestId: `${createdOrderId}-${Date.now()}`,
            orderId: createdOrderId,
            orderCode: createdOrderCode,
            supplierEmail: suppliersEmail ?? "",
            toggleActive: true,
          },
        });
      } else if (toggleActive) {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: "Rent order was created, but the email job could not start because the order id was missing.",
          },
          false,
        );
      } else {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: `Rent Order ${createdOrderCode || ""} was created successfully.`,
          },
          false,
        );
      }

      setShowSendEmailPopup(true);
      setLoader(false);
    } else {
      setApimessage(addPurchasingOrder?.message);
    }
  }, [addPurchasingOrder]);

  // for send email
  const [showSendEmailPopup, setShowSendEmailPopup] = useState(false);

  const handleClose22 = () => {
    setShowSendEmailPopup(false);
    setLoader(false);
    setIsClicked(false);
    setFilelist([]);
    setSearchPeople("");
    setSuppliersId("");
    setProjectSearchPeople("");
    setProjectId("");
    setDeliveryAddress("");
    dispatch(Fetchlastordercode());
  };

  ///////////// ASC Addpurchasingorder API End ///////////

  ///////////// ASC FOR MODAL POPUP START //////////

  const [typeField, setTypeField] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);
  const handleClose = () => setModalShow(false);

  const handleCancel = (e) => {
    setShowSendEmailPopup(false);
    dispatch(setStatusToFalse());
    history.push("/stock");
  };
  ///////////// ASC FOR MODAL POPUP END //////////

  //// ASC CLOSE DROP DOWN  CLICK OUT SIDE START /////
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      type_supplier_Drop_Ref.current &&
      !type_supplier_Drop_Ref.current.contains(event.target)
    ) {
      setShowDropPeople(false);
    }
    if (
      type_project_Drop_Ref.current &&
      !type_project_Drop_Ref.current.contains(event.target)
    ) {
      setShowProjectsPeople(false);
    }
    if (
      type_an_item_Drop_Ref.current &&
      !type_an_item_Drop_Ref.current.contains(event.target)
    ) {
      setShowProductsPeople(false);
    }
  };
  //// ASC CLOSE DROP DOWN  CLICK OUT SIDE END /////

  useEffect(() => {
    const isAddNewOrder = localStorage.getItem("isAddNewOrder") === "true";
    const currentData = localStorage.getItem("currentRentOrderData");
    if (!isAddNewOrder && currentData) {
      const data = JSON.parse(currentData);
      setSearchPeople(data.currentSupplierName);
      setSuppliersId(data.currentSupplierId);
      setFilelist(data.currentFileList || []);
      setProjectSearchPeople(data.currentProjectName);
      setProjectId(data.currentProjectId);
    }
  }, []);

  // ASC data from productlist screen start
  console.log("ascfilelist", filelist);
  useEffect(() => {
    if (locationState?.from === "ProductList_Screen") {
      setSearchPeople(locationState.historySuppliername);
      setSuppliersId(locationState.historySupplierid);
      dispatch(FetchProductBysupplierid(locationState.historySupplierid));
    }
  }, []);

  useEffect(() => {
    if (locationState?.from === "ProductList_Screen") {
      if (
        fetchProductBySupplierId?.status === true &&
        locationState?.historySuppliername !== ""
      ) {
        let filterFromID = locationState?.historyProductPartid;
        let filteredData = fetchProductBySupplierId.data.filter(
          (item) => item.productPartid === filterFromID,
        );

        let stockList = [];
        filteredData.map((item) => {
          return stockList.push({
            asc_productpartname: item.productpartname,
            asc_productPartid: item.productPartid,
            asc_productColor: item.color,
            asc_costprice: item.costprice,
            qty: item.quantity,
            // asc_instock: people.instock,
            asc_leadTime: item.leadtime,
            asc_Unit: item.unit,
            asc_itemid: item.itemid,
            discount: 0,
            weight: null,
            Total: item.costPrice * item.quantity,
          });
        });

        setFilelist(stockList);
      }
    }
  }, [fetchProductBySupplierId]);
  // ASC data from productlist screen end

  const calculateTotal = (costPrice, qty, discountPercentage) => {
    let total = costPrice * qty;
    const discountValue = (discountPercentage / 100) * total;
    return total - discountValue;
  };

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [rentPeriod, setrentPeriod] = useState({
    fromDate: new Date(),
    toDate: new Date(),
  });
  const [deliveryAddress, setDeliveryAddress] = useState();
  const [projectAddress, setProjectAddress] = useState("");
  const [isdeliveryAddressChecked, setIsDeliveryAddressIsChecked] =
    useState(false);
  const [fromDateOpen, setFromDateOpen] = useState(false);
  const [toDateOpen, setToDateOpen] = useState(false);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const handleDateChange = (key, date) => {
    setrentPeriod((prev) => ({
      ...prev,
      [key]: date,
    }));
  };

  useEffect(() => {
    if (projectAddress) {
      if (isdeliveryAddressChecked) {
        setDeliveryAddress(projectAddress);
      } else {
        setDeliveryAddress("");
      }
      console.log("DeliveryAddress updated to: ", projectAddress);
    }
  }, [projectAddress, isdeliveryAddressChecked]); // Dependency array includes projectAddress

  const handleDeliveryAddressToggle = () => {
    console.log("projectAddress==================>", projectAddress);
    // No need to set deliveryAddress here, it's managed by useEffect
    console.log("DeliveryAddress==========>", deliveryAddress);
    setIsDeliveryAddressIsChecked((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        fromDateRef.current &&
        !fromDateRef.current.contains(event.target) &&
        toDateRef.current &&
        !toDateRef.current.contains(event.target)
      ) {
        setFromDateOpen(false);
        setToDateOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [fromDateRef, toDateRef]);

  const DateRangePicker = ({
    fromDate,
    toDate,
    fromDateOpen,
    toDateOpen,
    setFromDateOpen,
    setToDateOpen,
    onDateChange,
    fromDateRef,
    toDateRef,
  }) => (
    <div className="d-flex align-items-center gap-2 gap-md-4 ps-0 ps-md-5">
      <p className="mb-0 ">
        {/* Rent Period */}
        {t("Rent Period")}
      </p>
      <div className="d-flex align-items-center" ref={fromDateRef}>
        <img
          style={{ cursor: "pointer", marginRight: "5px" }}
          src={Calender}
          alt=""
          onClick={() => setFromDateOpen((p) => !p)}
        />
        <AppDatePicker
          inputClassNames="date-picker-rent-order"
          open={fromDateOpen}
          selected={fromDate}
          onChange={(date) => onDateChange("fromDate", date)}
          onSelect={() => setFromDateOpen((p) => !p)}
          dateFormat="dd/MM/yyyy"
        />
      </div>
      <p className="mb-0">
        {/* To */}
        {t("To")}
      </p>
      <div className="d-flex align-items-center" ref={toDateRef}>
        <img
          style={{ cursor: "pointer", marginRight: "5px" }}
          src={Calender}
          alt=""
          onClick={() => setToDateOpen((p) => !p)}
        />
        <AppDatePicker
          inputClassNames="date-picker-rent-order"
          open={toDateOpen}
          selected={toDate}
          onChange={(date) => onDateChange("toDate", date)}
          onSelect={() => setToDateOpen((p) => !p)}
          dateFormat="dd/MM/yyyy"
        />
      </div>
    </div>
  );

  // Dropdown Menu
  const menu = (
    <div className="custom-address-card">
      <div className="form-check" style={{ marginBottom: "2.5rem" }}>
        <div className="custom-flex-container">
          {/* Checkbox input */}
          <input
            type="checkbox"
            id="rent"
            name="type"
            value="rent"
            className={`form-check-input custom-checkbox`} // Include Bootstrap's class and your custom class
            checked={isdeliveryAddressChecked} // Control the checked state
            onChange={handleDeliveryAddressToggle}
          />

          {/* Custom checkbox styling */}
          <div
            style={{
              cursor: "pointer",
              width: "16px",
              height: "16px",
              border: "2px solid #ccc",
              borderRadius: "50%", // Rounded like a radio button
              backgroundColor: isdeliveryAddressChecked
                ? "#00246A"
                : "transparent", // Fill background when checked
              position: "relative",
              zIndex: 0,
            }}
            onClick={handleDeliveryAddressToggle}
          />

          {/* Label and error message */}
          <div
            className="d-flex flex-column align-items-start"
            style={{ marginLeft: "14px", flex: 1 }} // Use flex: 1 to fill remaining space
          >
            <label
              htmlFor="rent"
              className="d-flex align-items-center" // Use align-items-center for vertical alignment
              style={{ cursor: "pointer" }}
            >
              {/* Same Project Work Address */}
              {t("Same Project Work Address")}
            </label>

            {/* Error message */}
            <p
              className={`text-danger ${
                projectSearchPeople === "" && isdeliveryAddressChecked
                  ? ""
                  : "invisible"
              }`}
              style={{
                position: "absolute", // Position it absolutely
                marginTop: "20px", // Adjust the top margin to position it below the label
              }}
            >
              {/* Select a project first */}
              {t("Select a project first")}
            </p>
          </div>

          <span
            onClick={() => setDropdownVisible(!dropdownVisible)}
            style={{ cursor: "pointer", marginLeft: "10px" }} // Adjusted margin to create space
          >
            <CrossCircleIcon />
          </span>
        </div>
      </div>

      {/* Address Textarea */}
      <div className="input-container" id="ascInput">
        <label className="asc-label-top projectNameText">
          {/* Delivery Address */}
          {t("delivery Address")}
        </label>

        <div className="maintenance-input ps-3">
          {/* <textarea
                        rows={2}
                        placeholder={"Add an address"}
                        className="clientText"
                        name="description"
                        value={deliveryAddress}
                        onChange={(e) => setDeliveryAddress(e.target.value)}
                    /> */}
          <GooglePlacesAutocomplete
            debounce={800}
            renderInput={(props) => (
              <textarea
                rows="4"
                className="DeliveryInput ps-3 bordered-inputs"
                cols="50"
                style={{
                  border: "none",
                  width: "100%",
                  // overflow: "hidden",
                  height: "65px",
                }}
                {...props}
                placeholder={t("Type an item")}
              />
            )}
            onSelect={(e) => {
              setDeliveryAddress(e.description);
              handleAddressSelect(e);
            }}
            initialValue={deliveryAddress}
            placeholder={"Add an address"}
          />
        </div>
      </div>

      {/* button */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "29px",
          alignItems: "center", // Center the button vertically
        }}
      >
        <button
          onClick={() => setDropdownVisible(!dropdownVisible)}
          style={{
            width: "106px",
            height: "33px",
            backgroundColor: "#00246A",
            color: "#ffffff",
            border: "none",
            borderRadius: "5px", // Optional: add rounded corners
            cursor: "pointer", // Change cursor on hover
          }}
        >
          {/* Add */}
          {t("Add")}
        </button>
      </div>
    </div>
  );

  const [pinCodeForAdress, setPinCodeForAdress] = useState("");

  // postal Code start
  const handleAddressSelect = (address) => {
    const { place_id } = address;
    geocodeByPlaceId(place_id)
      .then((res) => {
        console.log("Found the Address", res);

        if (res && res[0] && res[0].address_components) {
          const { long_name: postalCode = "" } =
            res[0].address_components.find((c) =>
              c.types.includes("postal_code"),
            ) || {};
          // setPinCodeForAdress(postalCode);

          if (!address.description.includes(postalCode)) {
            // setPinCodeForAdress(postalCode);
          }

          const { formatted_address, address_components } = res[0];
          setDeliveryAddress(formatted_address);
        }
      })
      .catch((err) => {
        console.log("Error while fetching address meta ", err);
      })
      .finally((done) => {
        console.log("Address API Call Completed ", done);
      });
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = [...filelist];

    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);

    setFilelist(items);
  };

  const handleSupplierIdChange = (index, value) => {
    const item = filelist?.[index];
    dispatch(
      SupplierCodeExistOrNot({
        itemid: item.asc_itemid,
      }),
    ).then((res) => {
      if (res?.status === true) {
        setIsSupplierCodeExist({
          status: true,
          suppCodeIndex: index,
        });
      } else {
        setIsSupplierCodeExist({
          status: false,
          suppCodeIndex: null,
        });
      }
    });
  };

  const [duplicateLoadingIndex, setDuplicateLoadingIndex] = useState(null);

  const handleDuplicate = async (index) => {
    setDuplicateLoadingIndex(index);

    const currentItem = filelist[index];
    // setFilelist((prev) => [
    //   ...prev,
    //   {
    //     ...currentItem,
    //     asc_productpartname: `copy-${currentItem.asc_productpartname.replace(
    //       /^copy-/,
    //       "",
    //     )}`,
    //     isCopy: true,
    //   },
    // ]);
    console.log("asc444", currentItem);
    // dispatch(
    //   AddProductPart({
    //     type: "Part",
    //     productpartcode: `PO-${Date.now()}`,
    //     barcode: currentItem.asc_BarCodeImg,
    //     productpartname: `copy-${currentItem.asc_productpartname}`,
    //     salepriceexcvat: currentItem.asc_costprice,
    //     productpartsuppliers: [
    //       {
    //         supplierid: currentItem.asc_SupplierId,
    //         itemid: currentItem.asc_itemid,
    //         costprice: currentItem.asc_costprice,
    //         leadtime: currentItem.asc_leadTime,
    //       },
    //     ],
    //   }),
    // );

    const productpartcode = `PO-${Date.now().toString(36)}`; // (8 chars)

    const barCodeRes = await dispatch(
      ProductpartBarCode({
        itemid: productpartcode,
      }),
    );

    const res = await dispatch(
      PartDuplicate({
        productpartid: currentItem.asc_productPartid,
        // productpartcode: `PO-${Date.now()}`, // (13 chars)
        productpartcode: productpartcode,
        productpartname: `copy-${currentItem.asc_productpartname}`,
        barcode: barCodeRes.data?.url,
        // productpartsuppliers: [
        //   {
        //     // supplierid: currentItem.asc_SupplierId,
        //     // itemid: currentItem.asc_itemid,
        //     supplierid: suppliersId,
        //     itemid: `PO-${Date.now().toString(36).slice(-6)}`,
        //     costprice: Number(currentItem.asc_costprice)
        //       .toFixed(2)
        //       .replace(".", ","),
        //     leadtime: currentItem.asc_leadTime,
        //   },
        // ],
      }),
    );

    if (res?.status === true) {
      setFilelist((prev) => [
        ...prev,
        {
          ...currentItem,
          // API response se values lo
          asc_productPartid: res.data.productPartid,
          asc_itemid: res.data.itemid,
          asc_BarCodeImg: res.data.barCode,
          asc_productpartname: res.data.productPartName,
          isCopy: true,
          asc_costprice: "",
          asc_leadTime: "",
        },
      ]);
    }
    setDuplicateLoadingIndex(null);
  };

  return (
    <>
      <Header
        leftComponent={
          <div className="d-flex flex-wrap gap-4 ps-4">
            <p
              className="projectText pointer mb-0"
              style={{ display: "flex", alignItems: "center" }}
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </p>
            <div
              className="d-flex pe-3 rounded"
              style={{
                background: "#FFFFFF",
                alignItems: "center",
              }}
            >
              <p className="ps-4 projectText2 mb-1">
                {/* Rent Order */}
                {t("Rent Order")}
              </p>
              <p className="ps-5 orderCode mb-0"> ID &nbsp;{poOrderCode} </p>
            </div>
          </div>
        }
      />
      {modalShow && (
        <CancelWarningModal
          show={modalShow}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeField !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeField !== "") {
            if (
              !["/add-purchasing-order", "/stock"].includes(location.pathname)
            ) {
              return true;
            }
          }
          return false;
        }}
      />

      {showSendEmailPopup && (
        <SendEmailROpopup
          show={showSendEmailPopup}
          onHide={handleClose22}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
          toggleActive={toggleActive}
          orderCode={orderCode}
        />
      )}

      <div className="d-flex flex-wrap justify-content-center justify-content-lg-between ps-5">
        <div className="d-md-none">
          <div className="d-flex flex-wrap gap-4 ps-4">
            <p
              className="projectText pointer mb-0"
              style={{ display: "flex", alignItems: "center" }}
              onClick={() => {
                history.push("/stock");
              }}
            >
              {t("Stock")}
            </p>
            <div
              className="d-flex pt-2 pe-3"
              style={{
                background: "#FFFFFF",
                alignItems: "center",
              }}
            >
              <p className="ps-4 projectText2">Rent Order</p>
              <p className="ps-5 orderCode mb-0">ID &nbsp;{poOrderCode}</p>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center w-100 mb-3 me-3">
          <DateRangePicker
            fromDate={rentPeriod.fromDate}
            toDate={rentPeriod.toDate}
            fromDateOpen={fromDateOpen}
            toDateOpen={toDateOpen}
            setFromDateOpen={setFromDateOpen}
            setToDateOpen={setToDateOpen}
            onDateChange={handleDateChange}
            fromDateRef={fromDateRef}
            toDateRef={toDateRef}
          />
          <div className="addAndCancelrobtn d-flex justify-content-end mt-3 mt-lg-0">
            <button
              type="button"
              className="addPurchCancel me-4"
              onClick={() => {
                if (typeField !== "") {
                  setModalShow(true);
                } else {
                  history.goBack();
                }
              }}
            >
              {t("Cancel")}
            </button>

            <button
              type="button"
              className="btn addPurchAdd fw-bold"
              onClick={HandleAddOrder}
              disabled={
                loader ||
                isSupplierCodeExist?.status ||
                !suppliersId ||
                !projectId ||
                filelist.length === 0 ||
                (location.state && location.state.fromQuotes)
              }
              style={{
                color:
                  filelist.length === 0 ||
                  !suppliersId ||
                  !projectId ||
                  loader ||
                  isSupplierCodeExist?.status
                    ? "#37393b"
                    : "#FFFFFF",
                fontSize: "14px",
              }}
            >
              {loader ? t("Adding") : t("Add")}
            </button>
          </div>
        </div>
      </div>

      <div className="PurchScrollWidth">
        <div className="supplierDiv ms-4 me-5 mt-5 ps- py-3">
          <table className="table table-borderless">
            <thead>
              <tr className="">
                <th className="col purchSupplier ps- d-none">
                  {/* Supplier */}
                  {/* {FetchTranslationList[11]?.translation} */}
                </th>
                <th className="col pt-1 ps-4" style={{ fontSize: "16px" }}>
                  <div
                    className="asc-input-container"
                    id="ascInput"
                    style={{
                      border: "1px solid #333333",
                      borderRadius: "6px",
                    }}
                    ref={type_supplier_Drop_Ref}
                  >
                    <label
                      className="asc-label-top ClientNameText input-label-font"
                      style={{ background: "#fff" }}
                    >
                      {/* Supplier */}
                      {t("Supplier")}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="asc_input"
                      ref={supplierFieldRef}
                      className="typeSupplier asc_NormalInput ps-3"
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#323232",
                        width: "90%",
                        border: "unset",
                        background: "white",
                      }}
                      // placeholder="Type a supplier"
                      placeholder={t("Type a supplier")}
                      value={searchPeople}
                      onChange={(e) => {
                        setSearchPeople(e.target.value);
                        setShowDropPeople(true);
                      }}
                      onFocus={() => {
                        setShowDropPeople(true);
                        setSearchPeople("");
                        setTypeField("asc");
                      }}
                    />

                    <img
                      src={Xicon}
                      className={
                        searchPeople
                          ? "purch_xicon pointer mx-2"
                          : "purch_xicon mx-2 invisible"
                      }
                      style={{}}
                      alt=""
                      onClick={() => {
                        setSearchPeople("");
                        setShowDropPeople(true);
                        setSuppliersId("");
                        setShowProductsPeople(false);
                      }}
                    />

                    {showDropPeople && (
                      <div
                        className="customSelect_Outer_purch"
                        id="ascSelectBox"
                      >
                        {suppliersData
                          ?.filter(
                            (item) =>
                              item.suppliername
                                ?.toLowerCase()
                                .includes(searchPeople.toLowerCase()),
                            // item.lastname?.toLowerCase().includes(searchPeople)
                          )
                          .map((people, index) => {
                            let existItem = false;
                            if (suppliersId === people.supplierid) {
                              existItem = true;
                            }
                            return (
                              <div
                                key={index}
                                style={{
                                  backgroundColor: existItem ? "#e4e4e4" : "",
                                }}
                                className="dropDown_peoples_flex ulterDrop w-100 m-0"
                                onClick={() => {
                                  // setSuppliersName(people.suppliername)
                                  setSearchPeople(people.suppliername);
                                  setSuppliersId(people.supplierid);
                                  setSuppliersEmail(people.email);

                                  dispatch(
                                    FetchProductBysupplierid(people.supplierid),
                                  );

                                  // dispatch(PO_Supplier_Props_API(people.suppliername,people.supplierid))

                                  setShowDropPeople(false);
                                }}
                              >
                                <p className="dropDownPeoples_purch">
                                  {people?.suppliername}
                                </p>
                              </div>
                            );
                          })}
                        {suppliersData.length === 0 && (
                          <span>
                            {/* No suppliers to display! */}
                            {t("No suppliers to display!")}
                          </span>
                        )}
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      minHeight: "20px",
                      minWidth: "220px",
                    }}
                  >
                    {suppliersId &&
                      suppliersId !== "00000000-0000-0000-0000-000000000000" &&
                      fetchProductsData.length === 0 && (
                        <p className="availableSupplier mb-0">
                          {/* No items are available for this supplier */}
                          {t("No items are available for this supplier")}
                        </p>
                      )}
                  </div>
                </th>

                {/* <th className=""></th> */}
                <th className="col purshProject ps-">
                  {/* Project */}
                  {/* {FetchTranslationList[13]?.translation} */}
                </th>
                <th className="col pt-1 ps-2">
                  <div
                    className="asc-input-container"
                    id="ascInput"
                    style={{
                      border: "0.5px solid #70707080",
                      borderRadius: "6px",
                    }}
                    ref={type_project_Drop_Ref}
                  >
                    <label
                      className="asc-label-top ClientNameText"
                      style={{ background: "#fff" }}
                    >
                      {/* Project */}
                      {t("Project")}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="typeSupplier asc_NormalInput ps-3"
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#323232",
                        width: "90%",
                        border: "unset",
                        background: "white",
                      }}
                      // placeholder="Type a project"
                      placeholder={t("Type a project")}
                      value={projectSearchPeople}
                      onChange={(e) => {
                        setProjectSearchPeople(e.target.value);
                        setShowProjectsPeople(true);
                      }}
                      onFocus={() => {
                        setShowProjectsPeople(true);
                        setProjectSearchPeople("");
                        setTypeField("asc");
                      }}
                    />

                    <img
                      src={Xicon}
                      className={
                        projectSearchPeople || showProjectsPeople
                          ? "purch_xicon pointer mx-2"
                          : "purch_xicon mx-2 invisible"
                      }
                      alt=""
                      onClick={() => {
                        setProjectSearchPeople("");
                        setProjectId("");
                        setShowProjectsPeople(!showProjectsPeople);
                      }}
                    />

                    {showProjectsPeople && (
                      <div
                        className="customSelect_Outer_purch"
                        style={{ height: "unset" }}
                      >
                        <div className="asc_Search_List ps-0" id="ascSelectBox">
                          {projectsData
                            ?.filter(
                              (item) =>
                                item.projectname
                                  ?.toLowerCase()
                                  .includes(
                                    projectSearchPeople.toLowerCase(),
                                  ) ||
                                item.projectcode
                                  ?.toLowerCase()
                                  .includes(projectSearchPeople.toLowerCase()),
                              // item.lastname?.toLowerCase().includes(projectSearchPeople)
                            )
                            .map((people, index) => {
                              let existItem = false;
                              if (projectId === people.projectid) {
                                existItem = true;
                              }
                              return (
                                <div
                                  key={index}
                                  style={{
                                    backgroundColor: existItem ? "#e4e4e4" : "",
                                  }}
                                  className="dropDown_peoples_flex ulterDrop w-100 m-0"
                                  onClick={() => {
                                    // setProjectSearchPeople(people.projectname);
                                    setProjectSearchPeople(
                                      `${people.projectcode} ┃ ${people.projectname}`,
                                    );
                                    setProjectId(people.projectid);
                                    setShowProjectsPeople(false);
                                    setProjectAddress(people.deliveryAddress);
                                  }}
                                >
                                  <p className="dropDownPeoples_purch">
                                    {people?.projectcode}
                                    &nbsp;┃&nbsp;
                                    {people?.projectname}
                                  </p>
                                </div>
                              );
                            })}
                          {projectsData.length === 0 && (
                            <span>
                              {/* No projects to display! */}
                              {t("Worktime")}
                            </span>
                          )}
                        </div>
                        {/* for button start*/}
                        <button
                          className="makeInvoBtn w-50 my-4"
                          style={{
                            marginLeft: "25%",
                          }}
                          onClick={() => {
                            setTypeField("");
                            setTimeout(() => {
                              history.push("/addProject", "/project");
                            }, 1000);
                          }}
                        >
                          {/* Create a Project */}
                          {t("Create  a project ")}
                        </button>
                        {/* for button end*/}
                      </div>
                    )}
                  </div>
                </th>

                <th className="col"></th>

                <th className="col ps-2" style={{ paddingTop: "35px" }}>
                  <AddPurchaseOrderDocument
                    poOrderCode={poOrderCode}
                    orderid={addPurchasingOrder?.data?.orderid}
                    isDisabled={false}
                  />
                </th>

                <th className="col"></th>

                <th
                  className="col purchSendSupp text-end ps- pt-5 text-nowrap"
                  style={{ width: "161px", height: "18px" }}
                >
                  {/* Send by email to supplier? */}
                  {t("Send by email to supplier?")}
                </th>

                <th className="col pt-5">
                  <div
                    className="ps-3"
                    style={{
                      width: "40px",
                      height: "22px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="asc_purch_Switch"
                      className="asc_pursh_Checkbox"
                      checked={toggleActive}
                      onChange={(e) => {
                        // if (seewageRoleTabDisable) {
                        //   setToggleActive(!toggleActive);
                        //   setTypeField(!toggleActive);
                        // }

                        setToggleActive(!toggleActive);
                        setTypeField(e.target.value);
                      }}
                      // disabled={memberNonActiveAccess === false}
                    />
                    <label
                      htmlFor="asc_purch_Switch"
                      className="asc_purch_Toggle"
                    >
                      {/* <p className=''>ASC</p> */}
                    </label>
                  </div>
                </th>

                <th className="col"></th>
              </tr>
            </thead>
          </table>
        </div>

        <div className="supplierDiv ms-4 px-4 mt-3 me-5 py-3">
          <div className="ps-2">
            {" "}
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              visible={dropdownVisible} // Control the visibility with state
              onVisibleChange={(flag) => setDropdownVisible(flag)}
            >
              <span className="cursor-pointer">
                <img className="plus-img me-2" src={PlusIcon} alt="plus" />
                {/* Add delivery address */}
                {t("Add delivery address")}
              </span>
            </Dropdown>
          </div>

          <DragDropContext onDragEnd={handleDragEnd}>
            <table className="table table-borderless m-0">
              <thead>
                <tr
                  className="purchSupplierCode ps-"
                  style={{
                    color: "#323232",
                    fontWeight: 600,
                    opacity: "50%",
                  }}
                >
                  <th></th>
                  <th
                    className="col-2 column2 pb-4 ps-3"
                    style={{
                      width: "35%",
                      paddingLeft: "10px",
                    }}
                  >
                    {/* Product Description */}
                    {t("Product Description")}
                  </th>

                  <th
                    className="col-1 column2 pb-4"
                    style={{
                      width: "50%",
                      paddingRight: "20px",
                    }}
                  >
                    {/* Supplier Code */}
                    {t("Supplier Code")}
                  </th>

                  <th
                    className="col-2 column2 text-center pb-4 ps-3"
                    style={{
                      width: "10%",
                      paddingLeft: "10px",
                    }}
                  >
                    {/* Unit Price */}
                    {t("Unit Price\t")}
                  </th>

                  <th
                    className="col-1 column1 text-center pb-4 ps-4"
                    style={{
                      width: "10%",
                      paddingLeft: "10px",
                    }}
                  >
                    {/* Qty */}
                    {t("Qty")}
                  </th>

                  <th
                    className="col-2 column2 text-center pb-4 ps-3"
                    style={{
                      width: "10%",
                      paddingLeft: "10px",
                    }}
                  >
                    {/* Unit */}
                    {t("Unit")}
                  </th>

                  <th
                    className="col-1 column1 text-center pb-4 ps-4"
                    style={{
                      width: "10%",
                      paddingLeft: "10px",
                    }}
                  >
                    {/* Lead Time */}
                    {t("Lead Time")}
                    <br />
                    <span className="">
                      {/* (Days) */}({t("Days")})
                    </span>
                  </th>

                  <th
                    className="col-1 column1 text-center pb-4 ps-4 d-none"
                    style={{
                      width: "10%",
                      paddingLeft: "10px",
                    }}
                  >
                    {/* Discount */}
                    {t("Discount")}
                  </th>

                  <th
                    className="col-4 column4 pb-4 purchTotal ps-4"
                    style={{
                      width: "15%",
                      paddingLeft: "95px",
                    }}
                  >
                    {/* Total */}
                    {t("Total")}
                  </th>
                  <th className="col-1"></th>
                  {/* <th className="col"></th> */}
                  {/* <th className="col"></th> */}
                </tr>
              </thead>

              <Droppable droppableId="filelist">
                {(dropProvided) => (
                  <tbody
                    ref={dropProvided.innerRef}
                    {...dropProvided.droppableProps}
                  >
                    {filelist.map((item, index) => {
                      const isCurrentSupplierError =
                        isSupplierCodeExist?.status &&
                        isSupplierCodeExist?.suppCodeIndex === index;
                      return (
                        <Draggable
                          key={`row-${index}`}
                          draggableId={`row-${index}`}
                          index={index}
                        >
                          {(dragProvided, snapshot) => {
                            return (
                              <tr
                                className="text-center"
                                ref={(el) => {
                                  dragProvided.innerRef(el);
                                  if (el && !snapshot.isDragging) {
                                    dragWidthsRef.current[index] = {
                                      row: el.offsetWidth,
                                      desc: el.children[1]?.offsetWidth,
                                    };
                                  }
                                }}
                                {...dragProvided.draggableProps}
                                style={{
                                  ...dragProvided.draggableProps.style,
                                  width: snapshot.isDragging
                                    ? dragWidthsRef.current[index]?.row
                                    : undefined,
                                }}
                              >
                                <td
                                  {...dragProvided.dragHandleProps}
                                  className="col-1 py-4 pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleDuplicate(index)}
                                >
                                  {duplicateLoadingIndex === index && (
                                    <SyncOutlined spin />
                                  )}
                                  =
                                </td>
                                <td
                                  className="col-2 column2 documntName text-start py-4"
                                  style={{
                                    ...(snapshot.isDragging && {
                                      width: dragWidthsRef.current[index]?.desc,
                                      minWidth:
                                        dragWidthsRef.current[index]?.desc,
                                      maxWidth:
                                        dragWidthsRef.current[index]?.desc,
                                    }),
                                    fontSize: "16px",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    if (item?.isCopy) return;
                                    if (item?.asc_itemid) {
                                      setTypeField("");
                                      setTimeout(() => {
                                        history.push({
                                          pathname: `/update-part/${item.asc_productPartid}`,
                                          state: {
                                            productPartId:
                                              item.asc_productPartid,
                                            productPartCode: item.asc_itemid,
                                            // productType: 1,
                                            productType:
                                              item.asc_ProductType === "Product"
                                                ? 0
                                                : item.asc_ProductType ===
                                                    "Part"
                                                  ? 1
                                                  : 1, // :2
                                          },
                                        });
                                        const orderDataToSave = {
                                          currentFileList: filelist,
                                          currentSupplierName: searchPeople,
                                          currentSupplierId: suppliersId,
                                          currentProjectName:
                                            projectSearchPeople,
                                          currentProjectId: projectId,
                                        };
                                        localStorage.setItem(
                                          "currentRentOrderData",
                                          JSON.stringify(orderDataToSave),
                                        );
                                        localStorage.removeItem(
                                          "isAddNewOrder",
                                        );
                                      }, 300);
                                    }
                                  }}
                                >
                                  {/* {item.asc_productpartname} */}
                                  {item?.isCopy ? (
                                    <input
                                      type="text"
                                      disabled={!item.isCopy}
                                      className="purchSupplierCode"
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "normal",
                                        width: "100%",
                                        border: isCurrentSupplierError
                                          ? "1px solid red"
                                          : "",
                                        display: item?.asc_SupplierId
                                          ? "none_e"
                                          : "",
                                      }}
                                      value={
                                        filelist[index]?.asc_productpartname ||
                                        ""
                                      }
                                      onChange={(e) => {
                                        const updatedFilelist = [...filelist];
                                        updatedFilelist[
                                          index
                                        ].asc_productpartname = e.target.value;
                                        setFilelist(updatedFilelist);
                                      }}
                                      onBlur={() => {
                                        dispatch(
                                          UpdateDuplicatePoPartName({
                                            productPartid:
                                              item.asc_productPartid,
                                            productname:
                                              filelist[index]
                                                ?.asc_productpartname,
                                          }),
                                        );
                                      }}
                                    />
                                  ) : (
                                    item.asc_productpartname
                                  )}
                                </td>

                                {/* {item.asc_itemid} */}
                                {/* <BarcodeGenerator textValue={item?.asc_itemid} /> */}
                                {/* supplier code input */}
                                <td className="col-2 column2 text-start ps- py-2">
                                  <img
                                    src={item?.asc_BarCodeImg}
                                    alt=""
                                    style={{ width: "100%", height: "70px" }}
                                  />
                                  <br />
                                  <input
                                    type="text"
                                    disabled={
                                      item?.asc_SupplierId === suppliersId &&
                                      !item?.isCopy
                                    }
                                    placeholder="Supplier code"
                                    className="purchSupplierCode ps-2"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      color: "#111111",
                                      width: "100%",
                                      borderRadius: "6px",
                                      border: isCurrentSupplierError
                                        ? "1px solid red"
                                        : "",
                                      display:
                                        item?.asc_SupplierId === suppliersId &&
                                        !item?.isCopy
                                          ? "none"
                                          : "",
                                    }}
                                    value={filelist[index]?.asc_itemid || ""}
                                    onChange={(e) => {
                                      const updatedFilelist = [...filelist];
                                      updatedFilelist[index].asc_itemid =
                                        e.target.value;
                                      setFilelist(updatedFilelist);

                                      handleSupplierIdChange(
                                        index,
                                        e.target.value,
                                      );
                                    }}
                                  />
                                  {isCurrentSupplierError && (
                                    <p
                                      className=""
                                      style={{
                                        fontSize: "10px",
                                        color: "red",
                                      }}
                                    >
                                      {/* Supplier id already exist */}
                                      {t("Supplier id already exist")}
                                    </p>
                                  )}
                                </td>

                                {/* <td className="col-1 column1 documntName ps-3 py-4">
                                  <ColorTag
                                    tagList={item.asc_productColor.map(
                                      (data) => ({
                                        color: data,
                                      }),
                                    )}
                                  ></ColorTag>
                                </td> */}

                                {/* Unit Price input */}
                                <td className="col-2 column2 documntName ps-3 py-4 fw-bold d-none">
                                  {europeanFormatWithSymbol(item.asc_costprice)}
                                </td>

                                <td className="col-2 column2 documntName ps-3 py-3 fw-bold">
                                  <CurrencyInput
                                    className="products-and-parts-stock-inputs products-and-parts-lead-time-input fw-bold"
                                    placeholder="0"
                                    name="unitprice"
                                    // disabled={item?.asc_SupplierId}
                                    // value={item.asc_costprice?.toString()?.replace(".", ",")}
                                    value={filelist[index]?.asc_costprice ?? ""}
                                    onChangeEvent={(e) => {
                                      const updatedFilelist = [...filelist];

                                      const price =
                                        convertToNumber(e.target.value) || 0;
                                      const qty =
                                        updatedFilelist[index].qty || 1;

                                      updatedFilelist[index].asc_costprice =
                                        price;
                                      updatedFilelist[index].Total =
                                        price * qty;

                                      setFilelist(updatedFilelist);

                                      setPriceChange((prev) => ({
                                        ...prev,
                                        [index]: true,
                                      }));
                                    }}
                                    decimalSeparator=","
                                    thousandSeparator="."
                                    precision="2"
                                    allowEmpty={true}
                                    prefix="€ "
                                    style={{
                                      // border: fieldErrors?.[index]?.costprice
                                      //   ? "1px solid red"
                                      //   : "",
                                      border: "none",
                                    }}
                                  />
                                </td>

                                {/* Quantity Input */}
                                <td className="col-1 column1 documntName py-4">
                                  <EuropeanInput
                                    className="purchSupplierCode text-center ps-2"
                                    style={{
                                      width: "70px",
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      color: "#111111",
                                    }}
                                    hidePreview={true}
                                    value={
                                      filelist[index].qty
                                        ? filelist[index].qty
                                        : 1
                                    } // Default to 1 if qty is not set
                                    onChange={(value) => {
                                      const updatedFilelist = [...filelist];

                                      // Update the quantity
                                      updatedFilelist[index]["qty"] = value;

                                      // Fetch the current cost price and discount
                                      const costPrice =
                                        convertToNumber(
                                          updatedFilelist[index][
                                            "asc_costprice"
                                          ],
                                        ) || 0;
                                      const discountPercentage =
                                        updatedFilelist[index]["discount"] || 0;

                                      // Recalculate total using the updated values
                                      const total = calculateTotal(
                                        costPrice,
                                        value,
                                        discountPercentage,
                                      );

                                      // Update the total in the filelist
                                      updatedFilelist[index]["Total"] = total;

                                      // Update the filelist to trigger re-render
                                      setFilelist([...updatedFilelist]);
                                    }}
                                    withoutSymbol={true}
                                  />
                                </td>

                                {/* Weight Input Unit */}
                                <td className="col-1 column1 documntName py-4 position-relative">
                                  <input
                                    type="text"
                                    className="asc_Client_Input_For_Long pointer"
                                    style={{
                                      width: "100%",
                                      cursor: item?.asc_SupplierId
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                    disabled={item?.asc_SupplierId}
                                    readOnly
                                    placeholder="_"
                                    value={item?.asc_Unit ?? ""}
                                    onFocus={() => {
                                      setTimeout(() => {
                                        setOpenUnitIndex(index);
                                      }, 500);
                                    }}
                                    onBlur={() => {
                                      setTimeout(() => {
                                        setOpenUnitIndex(null);
                                      }, 500);
                                    }}
                                  />
                                  {openUnitIndex === index && (
                                    <div
                                      className="asc_Custom_Select_Outer22"
                                      style={{
                                        width: "85px",
                                        top: "50px",
                                        left: "-25px",
                                        zIndex: 3,
                                      }}
                                    >
                                      <section
                                        className="asc_Search_List pt-0 p-3"
                                        id="ascSelectBox"
                                      >
                                        {unitData.map((unit, unitIndex) => {
                                          return (
                                            <div
                                              className=""
                                              onClick={(e) => {
                                                const updatedFilelist = [
                                                  ...filelist,
                                                ];

                                                updatedFilelist[
                                                  index
                                                ].asc_Unit = unit.unitname;

                                                setFilelist(updatedFilelist);
                                                setOpenUnitIndex(null);
                                              }}
                                            >
                                              {unit.unitname}
                                            </div>
                                          );
                                        })}
                                      </section>
                                    </div>
                                  )}
                                </td>

                                {/* Lead Time input */}
                                {/* <td className="col-1 column1 documntName py-4 fw-bold">
                                  {item?.asc_leadTime}
                                </td> */}

                                <td className="col-1 column1 documntName py-4">
                                  <input
                                    type="text"
                                    className="purchSupplierCode text-center ps-2"
                                    // disabled={item?.asc_SupplierId}
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      color: "#111111",
                                      width: "60px", // Adjust the width to be smaller
                                    }}
                                    placeholder="0"
                                    value={item?.asc_leadTime ?? ""}
                                    onChange={(e) => {
                                      const updatedFilelist = [...filelist];

                                      // Update the Lead time
                                      updatedFilelist[index].asc_leadTime =
                                        e.target.value !== ""
                                          ? e.target.value
                                          : null;

                                      // Update the filelist to trigger re-render
                                      setFilelist([...updatedFilelist]);

                                      setLeadTimeChange((prev) => ({
                                        ...prev,
                                        [index]: true,
                                      }));
                                    }}
                                  />
                                </td>

                                {/* Discount Input */}
                                <td className="col-1 column1 documntName py-4 d-none">
                                  <PercentageFormatter
                                    className="purchSupplierCode text-center ps-2 fw-bold"
                                    hidePreview={true}
                                    value={
                                      filelist[index].discount
                                        ? filelist[index].discount
                                        : discount
                                    }
                                    onChange={(value) => {
                                      const updatedFilelist = [...filelist];

                                      // Update the discount
                                      updatedFilelist[index]["discount"] =
                                        value;

                                      // Fetch the current cost price and quantity
                                      const costPrice =
                                        updatedFilelist[index][
                                          "asc_costprice"
                                        ] || 0;
                                      const qty =
                                        updatedFilelist[index]["qty"] || 1; // Default to 1 if qty is not set

                                      // Recalculate total using the updated values
                                      const total = calculateTotal(
                                        costPrice,
                                        qty,
                                        value,
                                      );

                                      // Update the total in the filelist
                                      updatedFilelist[index]["Total"] = total;

                                      // Update the filelist to trigger re-render
                                      setFilelist([...updatedFilelist]);
                                    }}
                                    withoutSymbol={false}
                                  />
                                </td>

                                <td className="col-1 column1 documntName py-4 text-center fw-bold">
                                  {europeanFormatWithSymbol(item.Total)}
                                </td>

                                <td className="py-4 ps-">
                                  <img
                                    className="dltIcon pointer"
                                    src={DeleteIcon}
                                    alt=""
                                    onClick={() => {
                                      let data = [...filelist];
                                      data.splice(index, 1);
                                      setFilelist(data);
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          }}
                        </Draggable>
                      );
                    })}
                    {dropProvided.placeholder}
                  </tbody>
                )}
              </Droppable>
            </table>
          </DragDropContext>

          <div className="horizontalLine"></div>

          <table className="table table-borderless m-0">
            <thead>
              <tr className="ps-">
                {/* <th className="col purchTypeItem py-4 ps-5">Type an item</th> */}

                <th className="col purchTypeItem py-4">
                  <div
                    className="asc_CustomSelect pt-2"
                    ref={type_an_item_Drop_Ref}
                  >
                    <input
                      type="text"
                      className="purchTypeItem"
                      placeholder={t("Type an item")}
                      // value={productsSearchPeople}
                      disabled={!suppliersId}
                      onChange={(e) => {
                        setProductsSearchPeople(e.target.value);
                        if (suppliersId) {
                          setShowProductsPeople(true);
                        } else {
                          setShowProductsPeople(false);
                        }
                      }}
                      onFocus={() => {
                        if (suppliersId) {
                          setShowProductsPeople(true);
                          setProductsSearchPeople("");
                          setTypeField("asc");
                        } else {
                          setShowProductsPeople(false);
                        }
                      }}
                    />

                    {/* {searchPeople && (
                        <img src={Xicon} className="purch_xicon pointer" alt=""
                          onClick={() => {
                            setProductsSearchPeople("");
                            setShowProductsPeople(true);
                          }}
                        />
                      )} */}

                    {showProductsPeople && suppliersId && (
                      <div
                        className="order-dropdown"
                        // id="ascSelectBox"
                      >
                        <div className="d-flex justify-content-between align-items-center bgdiv">
                          <p className="inputparts px-3">{t("Parts")}</p>
                          <div className="add-order w-100">
                            <input
                              className="update-member-input-noborder add-member-input bgforinput w-100"
                              value={productsSearchPeople}
                              onChange={(e) => {
                                setProductsSearchPeople(e.target.value);
                              }}
                              // placeholder="Search ... "
                              placeholder={t("Search...")}
                            />
                          </div>

                          <img
                            src={DelIcon}
                            alt=""
                            className="mx-2 cursor-pointer"
                            onClick={() => {
                              setShowProductsPeople(!showProductsPeople);
                              setProductsSearchPeople("");
                            }}
                          />
                        </div>
                        <div className="horizontal-line d-none"></div>
                        <div className="order-items-main gap-0 p-3">
                          {showLoader && (
                            <p className="text-center">
                              please wait while we fetching your data... &nbsp;{" "}
                              <SyncOutlined spin />
                            </p>
                          )}

                          {(productsSearchPeople
                            ? productsWithoutSupplier
                            : fetchProductsData
                          )
                            ?.filter(
                              (item) =>
                                item.productpartname
                                  ?.toLowerCase()
                                  .includes(
                                    productsSearchPeople?.toLowerCase(),
                                  ) ||
                                item.productpartdescription
                                  ?.toLowerCase()
                                  .includes(
                                    productsSearchPeople?.toLowerCase(),
                                  ) ||
                                item.suppliername
                                  ?.toLowerCase()
                                  .includes(
                                    productsSearchPeople?.toLowerCase(),
                                  ) ||
                                item.itemid
                                  ?.toLowerCase()
                                  .includes(
                                    productsSearchPeople?.toLowerCase(),
                                  ),
                            )
                            .map((people, index) => {
                              let existItem = false;
                              if (suppliersId === people.supplierid) {
                                existItem = true;
                              }
                              const isSupplierMatched =
                                people?.supplierid === suppliersId ||
                                people?.supplier?.[0]?.supplierid ===
                                  suppliersId;
                              console.log("asc456", people);
                              return (
                                <div
                                  key={index}
                                  style={{
                                    backgroundColor: existItem
                                      ? "#FFFFFF."
                                      : "",
                                  }}
                                  className="dropDown_peoples_flex1 justify-content-start"
                                  onClick={() => {
                                    const alreadyExists = filelist.some(
                                      (item) =>
                                        item.asc_productPartid ===
                                        people.productPartid,
                                    );

                                    if (alreadyExists) return;

                                    // setProductpartname(people.productpartname);

                                    // setProductsSearchPeople(people.productpartname);
                                    // setProductPartid(people.productPartid);
                                    // setProductColor(people.color);
                                    setCostprice(people.costprice);
                                    // setInstock(people.instock);
                                    // setItemid(people.itemid);
                                    setShowProductsPeople(false);

                                    setFilelist((pre) => [
                                      ...pre,
                                      {
                                        // asc_productpartname:
                                        //   people.productpartname,
                                        asc_productpartname: alreadyExists
                                          ? `copy-${people.productpartname}`
                                          : people.productpartname,
                                        isCopy: alreadyExists,
                                        asc_productPartid: people.productPartid,
                                        asc_productColor: people.color,
                                        asc_costprice: isSupplierMatched
                                          ? people.costprice ||
                                            people?.supplier?.[0]?.costprice
                                          : "",
                                        // asc_instock: people.instock,
                                        asc_leadTime: isSupplierMatched
                                          ? people.leadtime ||
                                            people?.supplier?.[0]?.leadtime
                                          : "",
                                        asc_Unit: people.unit,
                                        asc_itemid: people.itemid,
                                        asc_SupplierId:
                                          people.supplierid ||
                                          people?.supplier?.[0]?.supplierid,
                                        asc_ProductType: people.type || "",
                                        asc_BarCodeImg: people.barCode,
                                        Total: isSupplierMatched
                                          ? people.costprice * 1
                                          : "",
                                        cover: people.cover,
                                        image: people.image,
                                      },
                                    ]);
                                  }}
                                >
                                  <div title={people?.productpartname}>
                                    <p className="dropDownPeoples_purch productInMultiLine">
                                      {people?.productpartname}
                                    </p>
                                  </div>

                                  {isBuildingBlock && (
                                    <div className="title-hover">
                                      <div className="items-desc-column1">
                                        <div className="desc-image-wrp1 desc-image1 ">
                                          {people.cover ? (
                                            <>
                                              <div
                                                className={`product-list-image-default1 ${
                                                  people.image.length === 0
                                                    ? "hover-hide1"
                                                    : ""
                                                }`}
                                              >
                                                <img
                                                  src={people.cover}
                                                  alt=""
                                                  className="cover-image1"
                                                />
                                                {people.image &&
                                                  people.image.length > 0 && (
                                                    <div className="image-row1">
                                                      {people.image
                                                        .slice(0, 3)
                                                        .map((val, index) => (
                                                          <img
                                                            key={index}
                                                            src={val}
                                                            alt={`Images ${
                                                              index + 1
                                                            }`}
                                                          />
                                                        ))}
                                                    </div>
                                                  )}
                                              </div>
                                              {people.image &&
                                                people.image.length > 0 && (
                                                  <span className="desc-image-plus1">
                                                    <Image
                                                      height={10}
                                                      width={10}
                                                      src={plusBorderWhite}
                                                    />
                                                  </span>
                                                )}
                                            </>
                                          ) : (
                                            <div className="product-list-default1">
                                              <img
                                                src={Package}
                                                alt=""
                                                className="default-img1"
                                              />
                                              <div className="product-image-title d-none">
                                                {/* Picture */}
                                                {t("Picture")}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  <div
                                    className="ps-4"
                                    style={{
                                      color: "#323232",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* Stock */}
                                    {t("Stock")}
                                  </div>
                                  <div
                                    className="dropdown_color mx-3"
                                    style={{
                                      width: "30px",
                                      // height: "55px",
                                      borderRadius: "1px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: `${people.color}`,
                                      }}
                                      className="color-code"
                                    ></div>
                                  </div>

                                  <div className="info-items">
                                    {people.instock}
                                  </div>

                                  {!isSupplierMatched && (
                                    <div
                                      className="ms-auto"
                                      onClick={() => {
                                        setIsAddNewParts(!isAddNewParts);
                                      }}
                                    >
                                      <img
                                        src={circleCheck}
                                        className="opacity-50"
                                        alt=""
                                        width={20}
                                      />
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          {fetchProductsData.length === 0 && (
                            <span>
                              {/* No items to display! */}
                              {/* {FetchTranslationList[27]?.translation} */}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </th>
              </tr>
            </thead>
          </table>

          <div className="horizontalLine"></div>

          <table className="table table-borderless ms-4">
            <thead>
              <tr className="ps-">
                <th className="col-9"></th>
                <th
                  className="col-3 purchTotal2 text-center py-4 ps-3"
                  style={{
                    width: "15%",
                    paddingRight: "10px",
                  }}
                >
                  {/* TOTAL */}
                  {t("TOTAL")}
                </th>
                {/* <th className="col purchTotal2 py-4 ps-0"> {formattedCurrency(qty)} </th> */}
                <th
                  className="col purchTotal2 py-4 ps-0"
                  style={{
                    width: "14%",
                    paddingRight: "10px",
                  }}
                >
                  {europeanFormatWithSymbol(
                    filelist.reduce((a, b) => (a = a + b.Total), 0),
                  )}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </>
  );
};

export default AddRentOrder;
